<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="12" md="8">
        <v-autocomplete                    
          label="Cliente"
          v-model="multiSale.personId"
          :items="clients"
          item-value="id"
          item-text="name"                    
          autocomplete="off"
          @input="loadSales"
        />
      </v-col>
  
      <v-col cols="12" class="">
        <SaleIndex
          :sales="sales"
          :readOnly="readOnly"
          modelType="Sale"                    
          :hasTableTitle="true"
          tableTitle="Vendas abertas"
          @checkBoxSelectionListChanged="checkBoxSelectionListUpdated"
        />
      </v-col>
    </v-row>
    
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import BaseUtil from "@shared_components/base_util.vue"
import SaleIndex from "@models/sales/nfpe_multi_sales/index.vue"
import gql from 'graphql-tag';

export default {
  data() {
    return {
      entryAttributes: {},     
      pageLoading: false,
      // personId: {},
      salesLoading: false,
      sales: [],
    };
  },
  props: {
    entry: Object,
    clients: {
      type: Array,
      default: []
    },
    multiSale: {
      type: Object,
      default: () => {}
    },
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {    
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    BaseUtil: BaseUtil,
    SaleIndex: SaleIndex,
  },
  created() {
    // this.entryAttributes = this.setupEntryAttributes(this.entry);    
  },
  mounted() {
  },
  computed: {
    
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    checkBoxSelectionListUpdated: function(value){
      // console.log("value: ", value);
      this.multiSale.sales = value.map(sale => sale.id);
    },
    loadSales: function(){
      this.salesLoading = true;
      this.$apollo
        .query({
          query: LOAD_SALES,
          fetchPolicy: "no-cache",
          variables: {
            personId: this.multiSale.personId,            
          }
        })
        .then(response => {
          this.sales = response.data.accountContext.allSalesForClient;
          console.log("sales", this.sales);          
        })
        .catch(response => console.log(response))
        .finally(() => (this.salesLoading = false));
    },

    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    clearFields: function() {
      this.forceRerender(this);
    },
  }
};

const LOAD_SALES = gql `
  query($personId: ID!){
    accountContext{
      allSalesForClient(personId: $personId){
        id
        code
        totalPrice
        date
        dummyExitMovementItemsAttributes{
          id                   
          price
          item {
            name
          }
          packaging{
            name
          }
          packagingQuantity
          packagingUnitName
        }     
      }
    }
  }
`;


</script>

<style scoped>
  #saleSummary {
    color: gray;
  }
</style>
